module.exports = __webpack_public_path__ + "static/media/celebrate_upload.f34169ac.svg";